import { boardSlice } from "./boardSlice";
import {
  FilteredPagedQueryResult,
  FilteredPagedModel,
  CommonMultiDeleteModel,
} from "../../entities/common";
import {
  BourseGeneralInfoModel,
  FaraBourseGeneralInfoModel,
  GeneralInfoCommonInfoModel,
} from "../../entities/generalInfo";
import { TagTypes } from "./boardSlice";
import { getQuerySearchParams } from "../../utils";

export const generalInfoApi = boardSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GeneralInfo

    collectGeneralInfos: builder.mutation({
      query: () => ({
        url: "/generalInfo/collect",
        method: "POST",
      }),
      invalidatesTags: [
        { type: TagTypes.BourseGeneralInfo, id: "LIST" },
        { type: TagTypes.BourseGeneralInfo, id: "PARTIAL-LIST" },
        { type: TagTypes.FaraBourseGeneralInfo, id: "LIST" },
        { type: TagTypes.FaraBourseGeneralInfo, id: "PARTIAL-LIST" },
      ],
    }),

    getGeneralInfoCommonInfo: builder.query<
    GeneralInfoCommonInfoModel,
      undefined
    >({
      query: () => "/generalInfo/commonInfo",
      providesTags: [{ type: TagTypes.BourseGeneralInfo, id: "LIST" }, { type: TagTypes.FaraBourseGeneralInfo, id: "LIST" }],
    }),

    // BourseGeneralInfo

    getBourseGeneralInfosFilteredPaged: builder.query<
      FilteredPagedQueryResult<BourseGeneralInfoModel>,
      FilteredPagedModel
    >({
      query: ({
        page = 1,
        pageSize = 10,
        searchTerm = "",
        sortFieldName = "",
        descending = false,
        ...rest
      }: FilteredPagedModel) => {
        let url = `/generalInfo/bourse/pageable?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortFieldName=${sortFieldName}&descending=${descending}`;
        const restParams = getQuerySearchParams(rest);
        if (restParams) {
          url += `&${restParams}`;
        }
        return url;
      },
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TagTypes.BourseGeneralInfo, id: "PARTIAL-LIST" },
              ...result.data.map(({ id }) => ({
                type: TagTypes.BourseGeneralInfo,
                id,
              })),
            ]
          : [{ type: TagTypes.BourseGeneralInfo, id: "PARTIAL-LIST" }],
    }),
    getBourseGeneralInfo: builder.query<BourseGeneralInfoModel, number>({
      query: (recordId) => `/generalInfo/bourse/${recordId}`,
      providesTags: (result, error, arg) => [
        { type: TagTypes.BourseGeneralInfo, id: arg },
      ],
    }),
    deleteBourseGeneralInfo: builder.mutation({
      query: (recordId) => ({
        url: `/generalInfo/bourse/${recordId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              { type: TagTypes.BourseGeneralInfo, id: arg },
              { type: TagTypes.BourseGeneralInfo, id: "LIST" },
            ],
    }),
    deleteMultiBourseGeneralInfos: builder.mutation({
      query: (multiDeleteModel: CommonMultiDeleteModel) => ({
        url: "/generalInfo/bourse/multiDelete",
        method: "DELETE",
        body: multiDeleteModel,
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              ...arg.ids.map((id: number) => ({
                type: TagTypes.BourseGeneralInfo,
                id,
              })),
              { type: TagTypes.BourseGeneralInfo, id: "LIST" },
            ],
    }),

    // FaraBourseGeneralInfo

    getFaraBourseGeneralInfosFilteredPaged: builder.query<
      FilteredPagedQueryResult<FaraBourseGeneralInfoModel>,
      FilteredPagedModel
    >({
      query: ({
        page = 1,
        pageSize = 10,
        searchTerm = "",
        sortFieldName = "",
        descending = false,
        ...rest
      }: FilteredPagedModel) => {
        let url = `/generalInfo/faraBourse/pageable?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortFieldName=${sortFieldName}&descending=${descending}`;
        const restParams = getQuerySearchParams(rest);
        if (restParams) {
          url += `&${restParams}`;
        }
        return url;
      },
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TagTypes.FaraBourseGeneralInfo, id: "PARTIAL-LIST" },
              ...result.data.map(({ id }) => ({
                type: TagTypes.FaraBourseGeneralInfo,
                id,
              })),
            ]
          : [{ type: TagTypes.BourseGeneralInfo, id: "PARTIAL-LIST" }],
    }),
    getFaraBourseGeneralInfo: builder.query<FaraBourseGeneralInfoModel, number>(
      {
        query: (recordId) => `/generalInfo/faraBourse/${recordId}`,
        providesTags: (result, error, arg) => [
          { type: TagTypes.FaraBourseGeneralInfo, id: arg },
        ],
      }
    ),
    deleteFaraBourseGeneralInfo: builder.mutation({
      query: (recordId) => ({
        url: `/generalInfo/faraBourse/${recordId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              { type: TagTypes.FaraBourseGeneralInfo, id: arg },
              { type: TagTypes.FaraBourseGeneralInfo, id: "LIST" },
            ],
    }),
    deleteMultiFaraBourseGeneralInfos: builder.mutation({
      query: (multiDeleteModel: CommonMultiDeleteModel) => ({
        url: "/generalInfo/faraBourse/multiDelete",
        method: "DELETE",
        body: multiDeleteModel,
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              ...arg.ids.map((id: number) => ({
                type: TagTypes.FaraBourseGeneralInfo,
                id,
              })),
              { type: TagTypes.FaraBourseGeneralInfo, id: "LIST" },
            ],
    }),
  }),
});

export const {

    useCollectGeneralInfosMutation,
    useGetGeneralInfoCommonInfoQuery,

    useGetBourseGeneralInfosFilteredPagedQuery,
    useGetBourseGeneralInfoQuery,
    useDeleteBourseGeneralInfoMutation,
    useDeleteMultiBourseGeneralInfosMutation,

    useGetFaraBourseGeneralInfosFilteredPagedQuery,
    useGetFaraBourseGeneralInfoQuery,
    useDeleteFaraBourseGeneralInfoMutation,
    useDeleteMultiFaraBourseGeneralInfosMutation,
    
  } = generalInfoApi;